// extracted by mini-css-extract-plugin
export var footer = "Layout-module--footer--ef4f9";
export var main = "Layout-module--main--668ab";
export var nav = "Layout-module--nav--5e912";
export var root = "Layout-module--root--196fd";